export default __webpack_public_path__ + "static/media/folder.ed854daf.svg";